import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import App from './components/App';
import { DatadogProvider } from './components/Datadog/Datadog';
import type { Environment } from './config';

declare global {
  // Client Context
  interface Window {
    __CLIENT_CONTEXT: {
      jobAdPreview: any;
      hasError: any;
      uiMode: any;
      environment: Environment;
      version: string;
      language: any;
      locale: any;
    };
    __uiMode: any;
  }
}

const { jobAdPreview, hasError, environment, version, language, locale } =
  window.__CLIENT_CONTEXT;

const appElement = document.getElementById('app');

if (appElement) {
  hydrateRoot(
    appElement,
    <BrowserRouter>
      <DatadogProvider environment={environment} version={version}>
        <App
          jobAdPreview={jobAdPreview}
          hasError={hasError}
          language={language}
          locale={locale}
        />
      </DatadogProvider>
    </BrowserRouter>,
  );
} else {
  throw new Error("Element id 'app' not found during hydration");
}
